import { request } from '../../config/helpers/axios-instance'
import { toast } from 'react-toastify'

export const getRequestCallbackDetails = async (requestId) => {

    try {
        const response = await request({
            url: `requestCallback/admin/${requestId}`,
            method: 'GET',
        })
        if (response.data && response.data.success) {
            toast.success("Request callback details fetched successfully.")
            return response.data.data;
        }
        toast.warn("Couldn't fetch request callback details.")
        return null;
    } catch (error) {
        toast.warn("Couldn't fetch request callback details.")
        return null;
    }
}

export const getPrescriptionFromRequest = (requestCallback) => {
    const prescriptions = [];
    prescriptions.push({
        date: requestCallback.updatedAt,
        links: requestCallback.links
    });

    return prescriptions;
}

export const getPrescriptionsFromLogs = async (logs) => {
    const prescriptions = {
        links: [],
        formattedLinks: []
    };

    logs.forEach((log) => {
        const links = log?.data?.links;
        if (links) {
            prescriptions.formattedLinks.push({
                date: log.updatedAt,
                links: links.map((link) => {
                    if (link) {
                        return (link);
                    }
                })
            })
        }
    });

    logs.forEach((log) => {
        const links = log?.data?.links;
        if (links) {
            links.forEach((link) => {
                if (link) {
                    prescriptions.links.push(link);
                }
            })
        }
    });

    return prescriptions;
}

export const getUTMParamsFromLogs = async (logs) => {
    const utmParams = [];

    logs.forEach((log) => {
        const source = log?.data?.source || "";
        const medium = log?.data?.medium || "";
        const campaign = log?.data?.campaign || "";
        const utmParam = { source, medium, campaign };
        if (utmParam.source || utmParam.medium || utmParam.campaign) {
            utmParams.push(utmParam);
        }
    });
    return utmParams;
}